// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";

// Layouts
import AdminLayout from "./layouts/AdminLayout";
import PenyediaLayout from "./layouts/PenyediaLayout";
import SupervisorLayout from "./layouts/SupervisorLayout";
import SekolahLayout from "./layouts/SekolahLayout";

// Public
import PublicLayout from "./layouts/Public";
import UnitLayout from "./layouts/UnitMbg";
import EdukasiLayout from "./layouts/Edukasi";
import UnitLayoutSekolah from "./layouts/UnitSekolah";
import DetailLayout from "./layouts/Detail";

import AuthLayout from "./AuthLayout";
import LandingPage from "./LandingPage";

// Dashboard pages
import DashboardAdmin from "./pages/admin/DashboardAdmin";
import DashboardPenyedia from "./pages/penyedia/PenyediaDashboardPage";
import DashboardSupervisor from "./pages/supervisor/SupervisorDashboardPage";
import DashboardSekolah from "./pages/sekolah/SekolahDashboardPage";

export default function App() {
  return (
    <Routes>
      {/* Halaman Login (Publik) */}
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<AuthLayout />} />
      </Route>

      {/* ===================== ADMIN ===================== */}
      <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
        <Route path="/admin/*" element={<AdminLayout />}>
          <Route index element={<DashboardAdmin />} />
        </Route>
      </Route>

      {/* ===================== PENYEDIA ===================== */}
      <Route element={<ProtectedRoute allowedRoles={["penyedia"]} />}>
        <Route path="/penyedia/*" element={<PenyediaLayout />}>
          <Route index element={<DashboardPenyedia />} />
        </Route>
      </Route>

      {/* ===================== SUPERVISOR ===================== */}
      <Route element={<ProtectedRoute allowedRoles={["supervisor"]} />}>
        <Route path="/supervisor/*" element={<SupervisorLayout />}>
          <Route index element={<DashboardSupervisor />} />
        </Route>
      </Route>

      {/* ===================== sekolah ===================== */}
      <Route element={<ProtectedRoute allowedRoles={["sekolah"]} />}>
        <Route path="/sekolah/*" element={<SekolahLayout />}>
          <Route index element={<DashboardSekolah />} />
        </Route>
      </Route>

      {/* Halaman Landing (bebas akses) */}
        <Route path="/" element={<PublicLayout />} />
        <Route path="/unit" element={<UnitLayout />} />
        <Route path="/edukasi" element={<EdukasiLayout />} />
        <Route path="/school" element={<UnitLayoutSekolah />} />
        <Route path="/detail" element={<DetailLayout />} />
    </Routes>
  );
}
